import React, { Component } from "react";
import InfoCard from "./InfoCard";

class RightIntro extends Component {
  render() {
    const { title, chip, content = [], img } = this.props;

    return (
      <div className="container">
        <div className="row middle-sm">
          <div className="col-sm-7" style={{ paddingRight: 24 }}>
            {img && (
              <img
                src={img}
                className="img-shadow"
                width="100%"
                alt="content visual"
              />
            )}
          </div>
          <div className="col-md-5" style={{ paddingRight: 24 }}>
            {chip && <span className="chip m-0">{chip}</span>}
            {title && <h2 className="m-0">{title}</h2>}
            {Array.isArray(content) &&
              content.map((paragraph, index) =>
                paragraph ? <p key={index}>{paragraph}</p> : null
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default RightIntro;
